import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["hasUserBadge"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.string.link.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.string.trim.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import React from 'react';
import { useTranslation } from 'react-i18next';
import config from 'utils/config';
import { englifySearchValue, localiseSearchValue } from 'utils/search/translateSearchProps';
import createLocation from 'utils/createLocation';
import { useFetchMySearchContent } from 'actions/content';
import useFetchList from 'actions/useFetchList';
import { useFetchMindsetAgent } from 'actions/userProfile';
import useSearchParams from 'hooks/useSearchParams';
import { HighlightedContext } from 'hooks/useHighlightedText';
import useAriaFeedProps from 'hooks/useAriaFeedProps';
import Button from 'components/Button';
import EmptyStateController from 'components/EmptyStateController';
import Flex from 'components/Flex';
import { HorizontalCard, getCardDescriptionId, getCardSubtitleId, getCardTitleId, useCardController } from 'components/ContentCards';
import LoadMoreOnScroll from 'components/LoadMoreOnScroll';
import Tiles from 'components/Tiles';
import PageBackLink from 'components/PageBackLink';
import PageSection from 'components/PageSection';
import PageTitle from 'components/PageTitle';
import Stack from 'components/Stack';
import TagPill from 'components/Pill/PillVariants/TagPill';
import useCustomContactLink from '../../shared/useCustomContactLink';
import useOnWebAssetClick from '../../shared/useOnWebAssetClick';
import { useTopResultSummary, TopResultSummaryWidget } from './widgets/TopResultSummaryWidget';
import { CoachAiLauncherWidget } from './widgets/CoachAiLauncherWidget';
import { SearchWidgetLayout } from './widgets/SearchWidgetLayout';
function stripQuotes(input) {
  // Removes all quotation marks (including international variants) from input.
  return input.replace(/["'«»‘’“”„‟″＂＇]/g, '');
}
function ControlledHorizontalCard(_ref) {
  var data = _ref.data,
    feedItemProps = _ref.feedItemProps,
    wordsToHighlight = _ref.wordsToHighlight;
  var content = data.contentItem;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _useOnWebAssetClick = useOnWebAssetClick(),
    _onWebAssetClick = _useOnWebAssetClick.onWebAssetClick;
  var _useCardController = useCardController(_objectSpread(_objectSpread({}, data), {}, {
      onWebAssetClick: function onWebAssetClick() {
        if (content.type !== 'playlist' && content.type !== 'topic') {
          return _onWebAssetClick({
            type: content.type,
            markAsDoneMode: content.markAsDoneMode,
            userContentStatus: content.userContentStatus,
            contentId: content.id
          });
        }
      }
    })),
    hasUserBadge = _useCardController.hasUserBadge,
    contentItem = _objectWithoutProperties(_useCardController, _excluded);
  var additionalProps = {};
  // Snippet?
  if ('snippet' in content && content.snippet) {
    var _content$snippet = content.snippet,
      text = _content$snippet.text,
      position = _content$snippet.position;
    var assetLink = contentItem.link;
    contentItem.description = text;
    if (position) {
      // Add position to link
      var link = createLocation(assetLink, undefined, undefined, {
        position: position,
        search: wordsToHighlight
      });

      // Navigate to point in the document/video
      additionalProps.descriptionLink = {
        link: link,
        icon: 'search',
        title: t('search_results_within_info')
      };
    }
  }
  return /*#__PURE__*/React.createElement(HorizontalCard, _extends({}, contentItem, feedItemProps, additionalProps));
}
function SuggestedTags(_ref2) {
  var items = _ref2.items;
  if (items.length === 0) {
    return null;
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null, items.map(function (item) {
    return /*#__PURE__*/React.createElement(TagPill, {
      key: item.value,
      link: createLocation('/search', {
        term: englifySearchValue(item.value)
      })
    }, item.value.split(':').at(1));
  }));
}
function ContactButton() {
  var _useCustomContactLink = useCustomContactLink(),
    title = _useCustomContactLink.title,
    url = _useCustomContactLink.url,
    openModal = _useCustomContactLink.openModal;
  if (url) {
    return /*#__PURE__*/React.createElement(Button, {
      as: "a",
      size: "medium",
      variant: "shaded",
      href: url,
      target: "_blank"
    }, title);
  }
  return /*#__PURE__*/React.createElement(Button, {
    as: "button",
    size: "medium",
    variant: "shaded",
    onClick: openModal
  }, title);
}
function MissingResults(_ref3) {
  var hasResults = _ref3.hasResults,
    suggestedTags = _ref3.suggestedTags;
  var _useTranslation2 = useTranslation(),
    t = _useTranslation2.t;
  var hasSuggestions = suggestedTags && suggestedTags.length > 0;
  return /*#__PURE__*/React.createElement(Flex, {
    column: true,
    textAlign: "center",
    gap: "s"
  }, hasResults ? t('search_results_need_help_question') : t('search_results_empty'), ' ', hasSuggestions ? /*#__PURE__*/React.createElement(React.Fragment, null, t('search_results_try_tags'), ' ', /*#__PURE__*/React.createElement(SuggestedTags, {
    items: suggestedTags
  })) : /*#__PURE__*/React.createElement(ContactButton, null));
}
var PAGE_HEADING = 'search_results_title_heading';
function Search() {
  var _searchTermsQuery$ite, _contentQuery$meta, _contentQuery$items$a;
  var _useTranslation3 = useTranslation(),
    t = _useTranslation3.t;
  var _useSearchParams = useSearchParams(),
    _useSearchParams2 = _slicedToArray(_useSearchParams, 1),
    searchParams = _useSearchParams2[0];

  // Search request
  var searchValue = searchParams.term || '';
  var contentQuery = useFetchMySearchContent({
    searchValue: searchValue
  });
  var hasContentResults = contentQuery.items.length > 0;
  var isLoadingMoreItems = contentQuery.isFetching && !contentQuery.isLoading;
  var searchTermsQuery = useFetchList('me/content/searchTerms', {
    query: searchValue,
    limit: 5
  });
  var hasSuggestedSearchTerms = searchTermsQuery.items.length > 0;
  if (searchTermsQuery.items.length === 1 && searchValue === ((_searchTermsQuery$ite = searchTermsQuery.items.at(0)) === null || _searchTermsQuery$ite === void 0 ? void 0 : _searchTermsQuery$ite.value)) {
    hasSuggestedSearchTerms = false;
  }
  var _useTopResultSummary = useTopResultSummary(searchValue),
    summary = _useTopResultSummary.summary;
  var _useFetchMindsetAgent = useFetchMindsetAgent(),
    hasMindsetAgent = _useFetchMindsetAgent.hasMindsetAgent;
  var hasSearchWidget = Boolean(summary || hasMindsetAgent);
  var _useAriaFeedProps = useAriaFeedProps({
      isLoading: isLoadingMoreItems
    }),
    getWrapperProps = _useAriaFeedProps.getWrapperProps,
    getItemProps = _useAriaFeedProps.getItemProps;
  var wordsToHighlight = searchValue;
  if ('meta' in contentQuery && contentQuery !== null && contentQuery !== void 0 && (_contentQuery$meta = contentQuery.meta) !== null && _contentQuery$meta !== void 0 && _contentQuery$meta.searchTerms) {
    wordsToHighlight = contentQuery === null || contentQuery === void 0 ? void 0 : contentQuery.meta.searchTerms.join(' ');
  }
  return /*#__PURE__*/React.createElement(PageSection, null, /*#__PURE__*/React.createElement(PageBackLink, {
    fallback: "/home",
    basePath: "/search",
    mb: "xs"
  }), /*#__PURE__*/React.createElement(PageTitle, {
    size: "large",
    id: PAGE_HEADING,
    mb: "s"
  }, searchValue.trim() ? t('search_results_title_with_term', {
    searchInput: stripQuotes(localiseSearchValue(searchValue))
  }) : t('search_results_title')), hasSuggestedSearchTerms && hasContentResults && /*#__PURE__*/React.createElement(Flex, {
    wrap: true,
    gap: "xs",
    mb: "s"
  }, t('actions_search_by_tag_colon'), /*#__PURE__*/React.createElement(SuggestedTags, {
    items: searchTermsQuery.items
  })), /*#__PURE__*/React.createElement(SearchWidgetLayout, {
    widgets: hasSearchWidget && /*#__PURE__*/React.createElement(Tiles, {
      gap: "s",
      maxColumnCount: summary && config.mindsetAppUid ? 2 : 1,
      minColumnWidth: 250
    }, !!summary && /*#__PURE__*/React.createElement(TopResultSummaryWidget, {
      summary: summary,
      assetId: (_contentQuery$items$a = contentQuery.items.at(0)) === null || _contentQuery$items$a === void 0 ? void 0 : _contentQuery$items$a.id
    }), hasMindsetAgent && /*#__PURE__*/React.createElement(CoachAiLauncherWidget, null))
  }, /*#__PURE__*/React.createElement(EmptyStateController, {
    data: contentQuery.items,
    isLoading: contentQuery.isLoading,
    emptyContent: /*#__PURE__*/React.createElement(MissingResults, {
      hasResults: false,
      suggestedTags: hasSuggestedSearchTerms ? searchTermsQuery.items : null
    })
  }, /*#__PURE__*/React.createElement(HighlightedContext.Provider, {
    value: wordsToHighlight
  }, /*#__PURE__*/React.createElement(Stack, _extends({
    spacing: "l",
    mb: "l"
  }, getWrapperProps({
    labelledBy: PAGE_HEADING
  })), contentQuery.items.map(function (contentItem, index) {
    var goal = contentItem.goal,
      id = contentItem.id;
    var describedBy = "".concat(getCardSubtitleId(id), " ").concat(getCardDescriptionId(id));
    var contentItemData = {
      contentItem: contentItem,
      priorityPillType: goal ? 'goal' : undefined,
      progressLabelType: 'short',
      canSaveForLater: true
    };
    return /*#__PURE__*/React.createElement(ControlledHorizontalCard, {
      key: contentItem.id,
      data: contentItemData,
      wordsToHighlight: wordsToHighlight,
      feedItemProps: getItemProps({
        index: index,
        describedBy: describedBy,
        labelledBy: getCardTitleId(id)
      })
    });
  }))), /*#__PURE__*/React.createElement(MissingResults, {
    hasResults: true,
    suggestedTags: hasSuggestedSearchTerms ? searchTermsQuery.items : null
  }), /*#__PURE__*/React.createElement(LoadMoreOnScroll, {
    hasNextPage: contentQuery.hasNextPage,
    isFetchingNextPage: contentQuery.isFetchingNextPage,
    onFetchNextPage: contentQuery.fetchNextPage
  }))));
}
export default Search;